import React, { useContext, createContext, useReducer, useEffect, useRef } from 'react'
import { getEnvironment } from '../environment'
import { BrowserUtils } from '../utils/siteUtils'

const environment = getEnvironment()
const GlobalStateCtx = createContext(null)

const initialGlobalState = {
  width: BrowserUtils.isBrowser ? window.innerWidth : 0,
  height: BrowserUtils.isBrowser ? window.innerHeight : 0,
  activeTab: 'VIN',
  environment
}

const globalStateReducer = (state, action) => {
  const changed = []
  const redundant = []

  Object.keys(action).forEach(key => {
    if (state[key] !== action[key]) {
      changed.push({ key, old: state[key], new: action[key] })
    } else {
      redundant.push({ key, same: state[key] })
    }
  })

  let newstate = state

  if (changed.length) {
    newstate = { ...state, ...action }
  }

  return newstate
}

export default ({ children }) => {
  const [globalState, updateGlobalState] = useReducer(globalStateReducer, initialGlobalState)
  const { showModal, keyShiftMode, interactionReady } = globalState
  const globalVariables = useRef()
  const updateGlobalVariables = vars => {
    globalVariables.current = { ...globalVariables.current, ...vars }
  }
  useEffect(() => {
    const handleResize = () => {
      updateGlobalState({ width: window.innerWidth, height: window.innerHeight })
    }

    const handleDown = event => {
      if (event.target.type === 'text') {
        return
      }

      const { keyCode } = event

      if (keyCode === 16 && !keyShiftMode) {
        updateGlobalState({ keyShiftMode: true })
      } else if (keyCode === 27) {
        showModal ? updateGlobalState({ showModal: false }) : keyShiftMode ? window.history.forward() : window.history.back()
      }
    }

    const handleUp = ({ keyCode }) => {
      if (keyCode === 16 && keyShiftMode) {
        updateGlobalState({ keyShiftMode: false })
      }
    }

    window.addEventListener('keyup', handleUp)
    window.addEventListener('keydown', handleDown)
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('keyup', handleUp)
      window.removeEventListener('keydown', handleDown)
      window.removeEventListener('resize', handleResize)
    }
  }, [updateGlobalState, keyShiftMode, showModal])

  useEffect(() => {
    interactionReady && ['2019', '2000'].forEach(link => window.___loader.hovering(link))
  }, [interactionReady])

  const value = { globalState, updateGlobalState, globalVariables, updateGlobalVariables }

  return <GlobalStateCtx.Provider value={value}>{children}</GlobalStateCtx.Provider>
}

export const useGlobalState = initUpdateState => {
  const contextValues = useContext(GlobalStateCtx)
  const { globalState, updateGlobalState } = contextValues

  useEffect(() => {
    if (initUpdateState) {
      const newState = {}

      Object.keys(initUpdateState).forEach(key => {
        if (!(key in globalState)) {
          newState[key] = initUpdateState[key]
        }
      })

      if (Object.keys(newState).length) {
        updateGlobalState(newState)
      }
    }
  }, [globalState, updateGlobalState, initUpdateState])

  return contextValues
}
